import { useMediaQuery } from '@/lib/hooks/useMediaQuery';
import { Drawer, DrawerContent, DrawerTitle } from '@/components/ui/drawer';
import { useDashboardContext } from '@/stores/context/dashboard-layout-context';
import { useStore } from '@/stores';
import { BREAKPOINTS } from '@/lib/constants/breakpoints';
import { BusinessLogo } from '@/components/custom/business-logo';

import Logo from '../shared/logo';

import SidebarItems from './sidebar-items';
import QuickLogout from './quick-logout';

const Sidebar = () => {
  const isMediumView = useMediaQuery(BREAKPOINTS.md);
  const userProfile = useStore((state) => state.profile);
  const { isOpenDrawer, toggleSidebar } = useDashboardContext();

  if (isMediumView) {
    return (
      <>
        <div className="fixed z-[50] flex h-[calc(100vh-150px)] w-[254px] flex-col overflow-hidden rounded-md bg-white shadow">
          <div className="relative h-full">
            <div className="scrollbar-thin scrollbar-thumb-primary-main scrollbar-track-gray-300 relative h-[calc(100vh-211px)] overflow-y-auto px-4 pb-6">
              <SidebarItems />
            </div>
            <div className="sticky bottom-0 border-t bg-gray-50 px-4 py-2.5">
              <div className="flex flex-row items-center gap-2">
                {userProfile && (
                  <div
                    data-testid="sidebar-avatar-business-logo"
                    className="h-10 w-10 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-white"
                  >
                    <BusinessLogo model={userProfile.business.logo_path} />
                  </div>
                )}
                <span className="line-clamp-2 font-medium text-black">
                  {userProfile?.business.name || '-'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <Drawer direction="left" open={isOpenDrawer}>
      <DrawerContent
        data-testid="drawer-sidebar-mobile"
        onInteractOutside={toggleSidebar}
        aria-describedby={undefined}
      >
        <DrawerTitle>
          <Logo />
        </DrawerTitle>
        <SidebarItems />
        <QuickLogout />
      </DrawerContent>
    </Drawer>
  );
};

export default Sidebar;
